@if (carrouselItems$()) {
  <nav class="carrousel-menu">
    <div class="pb-xl-4 pb-0 pt-1 pt-xl-0">
      <ng-container [ngTemplateOutlet]="isXlScreen ? web : mobile"> </ng-container>
      <ng-template #web>
        <div class="carrousel-navbar navbar nav-top">
          <ul class="navbar-nav">
            <nav aria-label="Mes profils et contrats">
              <h2 class="sr-only p-0 m-0">Mes profils et contrats</h2>
              @for (carrouselItem of carrouselItems$(); track $index) {
                <li class="nav-item nav-bottom">
                  <ecm-carrousel-item
                    [carrouselItem]="carrouselItem"
                    [selectedLink]="selectedLink"
                    [carrouselLinksItemsSelected]="carrouselLinksItemsSelected"
                    [isSosh]="isSosh()"
                  ></ecm-carrousel-item>
                </li>
              }
            </nav>
            <nav aria-label="Mes infos, suivi et documents">
              <h2 class="sr-only p-0 m-0">Mes infos, suivi et documents</h2>
              @for (carrouselItem of carrouselLinksItems(); track $index) {
                <ecm-carrousel-item-new-link
                  [type]="carrouselItem.type"
                  [selected]="carrouselItem.selected"
                  class="d-none d-xl-block"
                ></ecm-carrousel-item-new-link>
              }

              @if (!isSosh()) {
                @if (isBloomActivated()) {
                  <ecm-carrousel-item-new-link
                    class="d-none d-xl-block"
                    [type]="'flagLinks.ORANGE_FIDELITE'"
                    [selected]="selectedLink === SelectedLink.AVANTAGES_CLIENT"
                  >
                  </ecm-carrousel-item-new-link>
                }

                @if (isCustomerBenefits$() && !isBloomActivated()) {
                  <ecm-carrousel-item-new-link
                    class="d-none d-xl-block"
                    [type]="'flagLinks.AVANTAGES_CLIENT'"
                    [selected]="selectedLink === SelectedLink.AVANTAGES_CLIENT"
                  >
                  </ecm-carrousel-item-new-link>
                }
              }

              @if (isOrangeServices$() && !isSosh()) {
                <ecm-carrousel-item-new-link
                  class="d-none d-xl-block"
                  [type]="'flagLinks.ORANGE_SERVICES'"
                  [selected]="selectedLink === SelectedLink.ORANGE_SERVICES"
                >
                </ecm-carrousel-item-new-link>
              }
            </nav>
          </ul>
        </div>
      </ng-template>
      <ng-template #mobile>
        <div class="carrousel-navbar navbar nav-top">
          <ul class="navbar-nav">
            @for (carrouselItem of carrouselItems$(); track $index) {
              <li class="nav-item nav-bottom mt-1" (click)="select(carrouselItem); (false)">
                <ecm-carrousel-item-mobile [carrouselItem]="carrouselItem"></ecm-carrousel-item-mobile>
              </li>
            }
          </ul>
        </div>

        @if (contracts$() && contracts$().length > 1) {
          <div class="carrousel-navbar navbar nav-top">
            <ul class="navbar-nav mb-1">
              @for (contract of contracts$(); track contract.cid; let i = $index) {
                <li class="nav-item nav-bottom mt-2">
                  <button
                    #buttonRef
                    class="carrousel-btn-offer mr-1 mb-0"
                    [id]="contract.cid"
                    [class.carrousel-selected]="contract.isSelected"
                    (click)="selectContract(i, contract.cid)"
                    type="button"
                  >
                    {{ contract.offerName }}
                  </button>
                </li>
              }
            </ul>
          </div>
        }
      </ng-template>
    </div>
  </nav>
}
